import { Loader2, Music4 } from "lucide-react";
import { coverSrc } from "@/lib/creatorApi";

const PALETTES = [
  "from-blue-500 via-violet-600 to-fuchsia-500",
  "from-emerald-400 via-teal-500 to-blue-600",
  "from-amber-400 via-orange-500 to-rose-500",
  "from-fuchsia-500 via-purple-600 to-indigo-600",
  "from-cyan-400 via-sky-500 to-violet-600",
];

function paletteFor(seed = "") {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) | 0;
  return PALETTES[Math.abs(h) % PALETTES.length];
}

/** AI cover art, or a styled gradient placeholder while it paints / if it fails. */
export default function SongCover({ song, className = "", size = "lg" }) {
  const src = coverSrc(song);
  const pending = song?.cover_status === "pending";
  const dims = size === "sm" ? "h-14 w-14 rounded-xl" : size === "md" ? "h-24 w-24 rounded-2xl" : "aspect-square w-full rounded-[28px]";
  return (
    <div
      data-testid="song-cover"
      data-cover-state={src ? "ready" : pending ? "pending" : "placeholder"}
      className={`relative overflow-hidden ${dims} ${className}`}
    >
      {src ? (
        <img src={src} alt={`Cover art for ${song?.title || "song"}`} className="h-full w-full object-cover" />
      ) : (
        <div className={`grid h-full w-full place-items-center bg-gradient-to-br ${paletteFor(song?.id || song?.title)}`}>
          <div aria-hidden className="absolute inset-0 opacity-30" style={{ backgroundImage: "radial-gradient(circle at 30% 30%, rgba(255,255,255,0.5), transparent 45%), radial-gradient(circle at 75% 70%, rgba(0,0,0,0.45), transparent 50%)" }} />
          {pending ? (
            <div className="relative flex flex-col items-center gap-2 text-white/90">
              <Loader2 className={`${size === "lg" ? "h-8 w-8" : "h-4 w-4"} animate-spin`} />
              {size === "lg" ? <span className="font-mono text-[10px] uppercase tracking-[0.2em]">Painting cover…</span> : null}
            </div>
          ) : (
            <Music4 className={`relative text-white/85 ${size === "lg" ? "h-16 w-16" : size === "md" ? "h-8 w-8" : "h-5 w-5"}`} />
          )}
        </div>
      )}
    </div>
  );
}
